import { Button } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import styles from "./LoginButton.module.css";
import { getRedirectUri, loginRequest } from "../../authConfig";
import { appServicesToken, appServicesLogout, checkUri } from "../../authConfig";
import { useNavigate } from "react-router-dom";
import * as msal from "@azure/msal-browser"; // Import the 'msal' module

type LoginButtonProps = {
    loginButtonMessage?: string;
    size?: "small" | "medium" | "large";
};

export const LoginButton = ({ loginButtonMessage, size }: LoginButtonProps) => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const isLoggedIn = (activeAccount || appServicesToken) != null;
    const navigate = useNavigate();
    const handleLoginPopup = async () => {
        /**
         * When using popup and silent APIs, we recommend setting the redirectUri to a blank page or a page
         * that does not implement MSAL. Keep in mind that all redirect routes must be registered with the application
         * For more information, please follow this link: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/login-user.md#redirecturi-considerations
         */

        try {
            await instance.loginPopup({ ...loginRequest, redirectUri: getRedirectUri() });
            navigate(checkUri("", instance));
        } catch (error) {
            console.log(error);
            if (error instanceof msal.InteractionRequiredAuthError) {
                // fallback to interaction when silent call fails and prompt the user to perform MFA
                return instance.loginPopup(loginRequest);
            } else {
                console.error(error);
            }
        }
    };
    const handleLogoutPopup = () => {
        if (activeAccount) {
            instance.logout().catch(error => console.log(error));
        } else {
            appServicesLogout();
        }
    };
    //const logoutText = `Logout\n${activeAccount?.name ?? appServicesToken?.user_claims?.preferred_username}`;
    return (
        <Button {...(size ? { size } : {})} className={styles.loginButton} variant="contained" onClick={isLoggedIn ? handleLogoutPopup : handleLoginPopup}>
            {isLoggedIn ? "Logout" : loginButtonMessage ?? "Login"}
        </Button>
    );
};
